import Vue from 'vue';

export const state = Vue.observable({
	collectArticle:{},
    articleFontsize: 'media',
    componentIndex:1,
    activeComponent:[]
})
export const mutations = {
    setFontSize(size){
        state.articleFontsize = size;
    },
    setCollectArticle(name){
        state.collectArticle=name;
    },
    setComponentIndex(componentIndex){
        state.componentIndex=componentIndex;
    },
    setActiveComponent(activeComponent){
        state.activeComponent=activeComponent;
    }
}